import { render, staticRenderFns } from "./uusi-suoritemerkinta.vue?vue&type=template&id=96beba94&scoped=true&"
import script from "./uusi-suoritemerkinta.vue?vue&type=script&lang=ts&"
export * from "./uusi-suoritemerkinta.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-suoritemerkinta.vue?vue&type=style&index=0&id=96beba94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96beba94",
  null
  
)

export default component.exports